import React from 'react'
import {reduxForm, formValueSelector} from 'redux-form'
import {connect} from 'react-redux'
import {withStyles} from '@material-ui/core/styles'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemText from '@material-ui/core/ListItemText'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Radio from '@material-ui/core/Radio'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import ClearIcon from '@material-ui/icons/Clear'
import { PHONE_REGEXP } from '../../../../../util/regExp'
import Text from '../../../../../uis/form/text'
import RadioForm from '../../../../../uis/form/radio'
import Select from '../../../../../uis/form/select'
import MultiSelect from '../../../../../uis/form/multiSelect'
import Datetime from '../../../../../uis/form/datetime'
import dateFormat from '../../../../../util/dateFormat'

const validate = values => {
    const errors = {}
    const requiredFields = ['name','phone','role','isActive']
    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = '必填'
        }
    })
    if (!PHONE_REGEXP.test(values.phone)) {
        errors.phone = '手机号格式不正确'
    }
    return errors
}

const formStyles = theme => ({
    root: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center'
    },
    head: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between'
    },  
    buttonStyle: {
        margin: 20,
        display: 'flex',
        justifyContent: 'space-around'
    },
})

class DetailForm extends React.Component {
    changeWorkStatus(e) {
        const {change} = this.props;
        if (e.target.value === '正常') {
            change('workJiaojieName', null);
            change('workJiaojieId', null);
            change('workLeaveStartTime', null);
            change('workLeaveEndTime', null);
        }
    }
    render() {
        const {handleSubmit,pristine,submitting,roleList,classes,onCancel, change, techs, workStatus} = this.props;
        const layoutStyle = { display: 'flex' }
        const radioStyle = {flexDirection: 'row'}
        const MenuProps = {
            PaperProps: {
              style: {
                maxHeight: 224,
                width: 250,
              },
            },
          };
        const selectStyle = {
            width: 500
        } 
        return (
            <div className={classes.root}>
                <div className={classes.head}>
                    <h3>请填写用户信息：</h3>
                    <IconButton onClick={onCancel} color="secondary"><ClearIcon /></IconButton>
                </div>
                <form onSubmit={handleSubmit}>
                    <Text name="name" label="名字" required={true} style={layoutStyle} placeholder="名字" />
                    <Text name="password" label="密码" required={false} style={layoutStyle} placeholder="密码" />
                    <Text name="phone" label="手机号" required={true} style={layoutStyle} placeholder="手机号" />
                    <MultiSelect name="roles" label="角色选择" multiple={true} MenuProps={MenuProps} style={selectStyle}>
                        {roleList.map((role) => (
                            <MenuItem key={role.id} value={role.name}>
                                <ListItemText primary={role.name} />
                            </MenuItem>
                        ))}
                    </MultiSelect>
                    <Text name="qq" label="QQ" required={false} style={layoutStyle} placeholder="QQ"  />
                    <Text name="email" label="Email" required={false} style={layoutStyle} placeholder="Email" />
                    <Text name="remarks" label="备注" style={layoutStyle} placeholder="备注" />
                    <RadioForm name="isActive" style={radioStyle} label="是否激活">
                        <FormControlLabel value='true' control={<Radio />} label="是" />
                        <FormControlLabel value='false' control={<Radio />} label="否" />
                    </RadioForm>
                    <hr/>
                    <Select name="workStatus" label="工作状态" placeholder="请输入工作状态" style={selectStyle} required={false} data={[{"name":"正常","value":'正常'},{"name":"请假","value":'请假'}]} onChange={(e) => this.changeWorkStatus(e)} />
                    {workStatus === '请假' && <Select name="workJiaojieName" label="工作交接人" placeholder="请输入工作交接人" style={selectStyle} required={workStatus === '请假'} data={techs.map(item=>({name: item.name, value: item.name}))} onChange={(e) => change('workJiaojieId', techs.find(item=>item.name === e.target.value).id)}/>}
                    {workStatus === '请假' && <Datetime name="workLeaveStartTime" type="datetime-local" label="请假开始日期" placeholder="请输入请假开始日期" className={classes.textField} required={workStatus === '请假'}/>}
                    {workStatus === '请假' && <Datetime name="workLeaveEndTime" type="datetime-local" label="请假结束日期" placeholder="请输入请假结束日期" className={classes.textField} required={workStatus === '请假'}/>}
                    <div className={classes.buttonStyle}>
                        <Button variant="outlined" color="secondary" type="submit" disabled={pristine || submitting}> 
                            确定
                        </Button>
                    </div>
                </form>
            </div>
        )
    }
}

export default connect(
    state => {
        const selector = formValueSelector('newUserForm');
        let initialValues;
        if (state.userManagement.userInfo.row && state.userManagement.userInfo.row.workLeaveStartTime) {
            initialValues = {
                ...state.userManagement.userInfo.row,
                workLeaveStartTime: dateFormat(new Date(state.userManagement.userInfo.row.workLeaveStartTime), 'yyyy-MM-ddTHH:mm'),
                workLeaveEndTime: dateFormat(new Date(state.userManagement.userInfo.row.workLeaveEndTime), 'yyyy-MM-ddTHH:mm'),
            }
            
        } else {
            initialValues = {...state.userManagement.userInfo.row}
        }
        return {
            initialValues,
            workStatus: selector(state, 'workStatus')
        }
    },
  )(reduxForm({
    form: 'newUserForm',
    validate
})(withStyles(formStyles)(DetailForm)))


// WEBPACK FOOTER //
// ./src/pages/home/routes/user/components/detailForm.js